import r from'./arrayWithHoles.js';import o from'./iterableToArrayLimit.js';import t from'./unsupportedIterableToArray.js';import e from'./nonIterableRest.js';function a(a,i){return r(a)||o(a,i)||t(a,i)||e()}export{a as default};
